<template>
  <div id="wording-type">
    <v-container grid-list-xl>
      <v-layout align-center row wrap>
        <v-flex sm10 xs12>
          <div class="headline">Shop Edition</div>
        </v-flex>
        <!-- <v-flex sm3 xs6>
          <v-autocomplete
            :items="users"
            clearable
            item-text="phone"
            item-value="phone"
            label="User"
            v-model="searchPhone"
          ></v-autocomplete>
        </v-flex>
        <v-flex sm3 xs6>
          <v-autocomplete
            :items="consultingTopics"
            clearable
            item-text="name"
            item-value="name"
            label="Topic"
            v-model="searchTopic"
          ></v-autocomplete>
        </v-flex>-->

        <v-flex sm2 text-xs-center xs12>
          <ShopEditionDialog />
        </v-flex>
        <v-flex xs12>
          <!-- Data Table -->
          <v-data-table
            class="elevation-0"
            disable-initial-sort
            :headers="headers"
            hide-actions
            :items="states"
            :loading="tableLoading"
          >
            <template slot="items" slot-scope="props">
              <tr @click="editItem(props.item.idx)">
                <td>{{ props.item.idx }}</td>
                <td>{{ props.item.name || '-' }}</td>
                <td>{{ props.item.hashtag || '-' }}</td>
                <td>{{ props.item.keyword || '-' }}</td>
                <td>{{ props.item.description || '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import store from '@/store'

import ShopEditionDialog from '@/components/admin/ShopEditionDialog'
export default {
  name: 'wording-type',
  components: {
    ShopEditionDialog
  },
  data() {
    return {
      users: [],
      searchPhone: '',
      searchTopic: '',
      // Table
      tableLoading: false,
      headers: [
        { text: 'ID', align: 'left', value: 'idx', width: '10' },
        { text: 'Name', align: 'left', value: 'name', width: '200' },
        { text: 'Hashtag', align: 'left', value: 'hashtag', width: '200' },
        { text: 'Keyword', align: 'left', value: 'keyword', width: '200' },
        { text: 'Desc', align: 'left', value: 'description', width: '300' }
      ]
    }
  },
  beforeRouteEnter: (to, from, next) => {
    store.state.ShopEdition.data.length === 0 // main fetch
      ? store.dispatch('ShopEdition/fetch').then(next())
      : next()
    // if (store.state.Types.data.length === 0) store.dispatch('Types/fetch')
  },
  computed: {
    states() {
      return this.$store.getters['ShopEdition/getAll']
    }
  },
  created() {},
  methods: {
    editItem(idx) {
      this.$store.commit('ShopEdition/UPDATE_DIALOG', true)
      this.$store.commit('ShopEdition/SET_IDX', idx)
    }
  }
}
</script>

<style lang="scss" scoped></style>
